module.exports = __webpack_public_path__ + "img/icons BFr_6.c64354a0.png";